if (typeof LotteryRG === 'undefined') {


    const LotteryRG = class {
        constructor() {
            if (LotteryRG.instance) {
                return LotteryRG.instance;
            }
            // Token 相关配置
            const APP_ENV = window.renogyConfig.mode;
            this.ACCESS_TOKEN_KEY = `renogy_account_access_token_key_${APP_ENV}_1.0`;
            this.REFRESH_TOKEN_KEY = `renogy_account_refresh_token_key_${APP_ENV}_1.0`;
            
            this.accessToken = this.getCookie(this.ACCESS_TOKEN_KEY);
            this.refreshToken = this.getCookie(this.REFRESH_TOKEN_KEY);
            this.userInfo = null;
            this.merberData = null;
            this.subscribeEmailInfo = null;
            this.pageCouponTemplateData = null;
            this.giftCardCouponData = null;
            this.productCardCouponData = null;
            this.exchangeResult = null;
            this.exchangeGiftCardResult = null;
            this.API_DOMAIN = window.renogyConfig.apiUrl;
            this.storeId = window.renogyConfig?.storeId || '1';
            this.submitBtn = null;
            this.activity = 'Sub0601';
            this.tagName = null;
            this.storeName = this.getSite().site;
            this.apiUrl = this.getSite().apiUrl;
            this.maxTime = 5;
            this.hasDrawTime = null;
            this.closeBtnHtml = `<svg xmlns="http://www.w3.org/2000/svg" width="26" height="26" viewBox="0 0 26 26" fill="none">
                <rect x="1" y="1" width="24" height="24" rx="12" fill="white" fill-opacity="0.3"/>
                <rect x="6.33295" y="18.4546" width="17.1429" height="1.71429" rx="0.857143" transform="rotate(-45 6.33295 18.4546)" fill="#1C1C1C"/>
                <rect x="18.4548" y="19.667" width="17.1429" height="1.71429" rx="0.857143" transform="rotate(-135 18.4548 19.667)" fill="#1C1C1C"/>
            </svg>`
            this.toastErrorIcon = `<svg xmlns="http://www.w3.org/2000/svg" width="28" height="28" viewBox="0 0 28 28" fill="none">
                <rect x="5" y="5" width="18" height="18" rx="9" stroke="#E04700" stroke-width="2"/>
                <circle cx="14" cy="10.1992" r="1" fill="#E04700"/>
                <rect x="13" y="12" width="2" height="6.8" rx="1" fill="#E04700"/>
            </svg>`
            this.toastTipsIcon = `<svg xmlns="http://www.w3.org/2000/svg" width="28" height="28" viewBox="0 0 28 28" fill="none">
            <rect x="6" y="8" width="16" height="16" rx="8" stroke="#00C0FF" stroke-width="2" stroke-linecap="round"/>
            <path d="M14 12V15.6C14 15.8209 14.1791 16 14.4 16H18" stroke="#00C0FF" stroke-width="2" stroke-linecap="round"/>
            <line x1="12" y1="5" x2="16" y2="5" stroke="#00C0FF" stroke-width="2" stroke-linecap="round"/>
            <path d="M15 7.29961L13 7.29961L13 4.59961L15 4.59961L15 7.29961Z" fill="#00C0FF"/>
            <line x1="20" y1="9.58579" x2="20.99" y2="8.59584" stroke="#00C0FF" stroke-width="2" stroke-linecap="round"/>
            </svg>`;
            this.prizeData = window.lotteryBlocksData || null;

            // Token 刷新相关变量
            this.isRefreshing = false;
            this.refreshPromise = null;
            this.pendingRequests = [];


            this.lotteryRGContainer = document.querySelector('[data-lottery-rg-container]');
            this.form = document.querySelector('[data-lottery-rg-form]');
            // for test
            if(window.location.hostname === '127.0.0.1') {
                this.apiUrl = 'https://d79a56e0d9be.ngrok-free.app'
                this.accessToken = 'eyJhbGciOiJIUzUxMiJ9.eyJpZCI6OTAxNzQ2LCJlbWFpbCI6IjE0NDIxMjM1MTBAcXEuY29tIiwic3VwcG9ydF9yZWZyZXNoIjp0cnVlLCJqdGkiOiJaVE5rWW1Zd01qa3RNbU5qWlMwMFpXVmlMVGhqT1dVdE5UTmtOVFk0T0dNM09UZG0iLCJpYXQiOjE3NjEwMzg0NzcsImV4cCI6MTc2MTEyNDg3N30.FABFXLusqOjgW-ySjLfsVT_wrgMONSvkqRukZZG8CH6Xr09hdE-grvNDe_o74YVqZyzeOhC4Q8_Yiiw_MDP0VA'
                this.refreshToken ='eyJhbGciOiJIUzUxMiJ9.eyJpZCI6OTAxNzQ2LCJpYXQiOjE3NjEwMzg0NzcsImp0aSI6Illqa3habUpoTURjdE5EZG1ZeTAwWlRVMUxXRXpZbU10TldKa05qVTBNVGxsTmpSaSJ9.FBKBRsLR8awJTlbu3WjvmuXelkjOItgCZs18scZuJPfn4TOdoF5zPTPhdkonWTt5UO9OxJz6ljPAU36Z_InW8A'
            }


            // 多语言文本配置
            this.enMessages = {
                couponInfo: {
                    out_of_stock: 'Out Of Stock',
                    coupon_text:"Available Over",
                    available: 'Available',
                    usage_rules: 'Usage Rules',
                    redeem_text: 'Redeem With',
                    redeem:'Redeem',
                    rays: 'Rays',
                    valid_until: "Valid Until",
                    redeem_copy:"Copy and Use",
                    gift_card_code: 'Gift Card Code:',
                    check_email: 'Check Your Email',
                    free:"Free",
                    code:"Code",
                    coupon:"Coupon",
                    permanent_valid_text:"Permanent Valid",
                    no_draw_time_tips:"Daily spins used up. Join next time!",
                    rules:"Rules:",
                    off:"OFF"
                },
                invalid_email: 'Please enter a valid email address'
            };
            this.deMessages = {
                couponInfo: {
                    out_of_stock: 'Nicht vorrätig',
                    coupon_text: 'Verfügbar über',
                    available: 'Verfügbar',
                    usage_rules: 'Verwendungsregeln',
                    redeem_text: 'Einlösen mit',
                    redeem:'Einlösen',
                    rays: 'Rays',
                    valid_until: 'Gültig bis',
                    redeem_copy:"Kopieren und Verwenden",
                    gift_card_code: 'Geschenkkartencode:',
                    check_email: 'Überprüfen Sie Ihre E-Mail',
                    free:"Kostenlos",
                    code:"Code",
                    coupon:"Gutschein",
                    no_draw_time_tips:"Tägliche Drehungen aufgebraucht. Nächstes Mal dabei sein!",
                    permanent_valid_text:"Unbefristet gültig",
                    rules:"Regeln:",
                    off:"AUS"

                },
                invalid_email: 'Bitte geben Sie eine gültige E-Mail-Adresse ein'
            };
            this.jaMessages = {
                couponInfo: {
                    out_of_stock: '在庫切れ',
                    coupon_text: '以上で利用可能',
                    available: '利用可能',
                    usage_rules: '利用規則',
                    redeem_text: 'で交換',
                    redeem:'redeem',
                    rays: 'Rays',
                    valid_until: '有効期限',
                    redeem_copy:"コピーして使用",
                    gift_card_code: 'ギフトカードコード：',
                    check_email: 'メールを確認',
                    free:"無料",
                    code:"コード",
                    coupon:"クーポン",
                    no_draw_time_tips:"本日の回数制限です。次回ご参加ください！",
                    permanent_valid_text:"永久有効",
                    rules:"ルール:",
                    off:"オフ"
                },
                invalid_email: '有効なメールアドレスを入力してください'
            };
            this.frMessages = {
                couponInfo: {
                    out_of_stock: 'En rupture de stock',
                    coupon_text: "Disponible dès",
                    available: 'Disponible',
                    usage_rules: 'Règles d\'utilisation',
                    redeem_text: 'Utiliser avec',
                    redeem:'Utiliser',
                    rays: 'Rays',
                    valid_until: "Valable jusqu'au",
                    redeem_copy:"Copier et utiliser",
                    gift_card_code: 'Code de carte cadeau :',
                    check_email: 'Vérifiez vos emails',
                    free:"Gratuit",
                    code:"Code",
                    coupon:"Coupon",
                    permanent_valid_text:"Valable à vie",
                    no_draw_time_tips:"Tours quotidiens épuisés. À la prochaine !",
                    rules:"Règles:",
                    off:"ARRÊT"
                },
                invalid_email: 'Veuillez saisir une adresse e-mail valide'
            };
            this.nlMessages = {
                couponInfo: {
                    out_of_stock: 'Niet op voorraad',
                    coupon_text: 'Beschikbaar vanaf',
                    available: 'Beschikbaar',
                    usage_rules: 'Gebruiksregels',
                    redeem_text: 'Inwisselen met',
                    redeem:'Inwisselen',
                    rays: 'Rays',
                    valid_until: 'Geldig tot',
                    redeem_copy:"Kopiëren en gebruiken",
                    gift_card_code: 'Cadeauboncode:',
                    check_email: 'Controleer uw e-mail',
                    free:"Gratis",
                    code:"Code",
                    coupon:"Coupon",
                    permanent_valid_text:"Permanent geldig",
                    no_draw_time_tips:"Je dagelijkse draaiingen zijn op! Doe volgende keer nou weer mee!",
                    off:"UIT"

                },
                invalid_email: 'Voer een geldig e-mailadres in'
            };
            this.esMessages = {
                couponInfo: {
                    out_of_stock: 'Agotado',
                    coupon_text: "Disponible sobre",
                    available: 'Disponible',
                    usage_rules: 'Reglas de uso',
                    redeem_text: 'Canjear con',
                    redeem:'Canjear',
                    rays: 'Rays',
                    valid_until: "Válido hasta",
                    redeem_copy:"Copiar y usar",
                    gift_card_code: 'Código de tarjeta regalo:',
                    check_email: 'Revisa tu correo electrónico',
                    free:"Gratis",
                    code:"Código",
                    coupon:"Cupón",
                    no_draw_time_tips:"Giros diarios agotados. ¡Únete la próxima vez!",
                    permanent_valid_text:"Válido a perpetuidad",
                    rules:"Reglas:",
                    off:"APAGADO"

                },
                invalid_email: 'Por favor ingrese una dirección de correo electrónico válida'
            };
            this.itMessages = {
               couponInfo: {
                    out_of_stock: 'Esaurito',
                    coupon_text: "Disponibile sopra",
                    available: 'Disponibile',
                    usage_rules: 'Regole di utilizzo',
                    redeem_text: 'Riscatta con',
                    redeem:'Riscatta',
                    rays: 'Rays',
                    valid_until: "Valido fino a",
                    redeem_copy:"Copia e usa",
                    gift_card_code: 'Codice della carta regalo:',
                    check_email: 'Controlla la tua email',
                    free:"Gratis",
                    code:"Codice",
                    coupon:"Coupon",
                    no_draw_time_tips:"Giri del giorno finiti! Ci ritroviamo alla prossima!",
                    permanent_valid_text:"Valido a tempo indeterminato",
                    rules:"Regole:",
                    off:"SPENTO"
                },
                invalid_email: 'Inserisci un indirizzo email valido'
            };


            // 根据语言选择对应版本
            const locale = window.Shopify?.locale || 'en';
            switch (locale.toLowerCase()) {
                case 'de':
                    this.messages = this.deMessages;
                    this.lang = 'de';
                    break;
                case 'ja':
                    this.messages = this.jaMessages;
                    this.lang = 'ja';
                    break;
                case 'fr':
                    this.messages = this.frMessages;
                    this.lang = 'fr';
                    break;
                case 'nl':
                    this.messages = this.nlMessages;
                    this.lang = 'nl';
                    break;
                case 'es':
                    this.messages = this.esMessages;
                    this.lang = 'es';
                    break;
                case 'it':
                    this.messages = this.itMessages;
                    this.lang = 'it';
                    break;
                default:
                    this.messages = this.enMessages;
                    break;
            }
            LotteryRG.instance = this;
        }

        async init() {
            if(this.lotteryRGContainer) {
                this.submitBtn = this.lotteryRGContainer.querySelector('.subscript-button');
                this.showViewPrizeButton();
                if(this.lotteryRGContainer.querySelector('.rg-lottery-content-left-learn-more-rules-button')){
                    this.lotteryRGContainer.querySelector('.rg-lottery-content-left-learn-more-rules-button').addEventListener('click', (event) => {
                        if(!event.target.href){
                            event.preventDefault();
                            this.learnMoreRules();
                        }
                        
                    });
                }
                this.initEventListeners();
            }
        }


        // 初始化blocks数据
        initBlocksData() {
            console.log('Lottery blocks data:', this.blocks);
            console.log('Section settings:', this.sectionSettings);
            
            // 可以根据需要处理blocks数据
            this.processBlocksData();
        }

        // 判断是否显示 view prize
        showViewPrizeButton() {
            let lotteryUserList = localStorage.getItem('lotteryUserList');
            if(lotteryUserList) {
                this.lotteryUserList = JSON.parse(lotteryUserList);
                this.lotteryRGContainer.querySelector('.rg-lottery-content-left-view-prize').style.display = 'flex';
            }
            if(this.lotteryRGContainer.querySelector('.rg-lottery-content-left-view-prize-button')){
                this.lotteryRGContainer.querySelector('.rg-lottery-content-left-view-prize-button').addEventListener('click', (event) => {
                    event.preventDefault();
                    event.stopPropagation();
                    this.viewPrizePopup();
                });
            }
            document.addEventListener('click', (event) => {
                if (event.target.classList.contains('membership-coupon-b-top-button-copy')&&event.target.getAttribute('data-copy-coupon')) {
                    this.copyToClipboard(event.target.getAttribute('data-copy-coupon'),event.target);
                }
            })
        }

        copyToClipboard(coupon,copyButton){
            let coupon_ = JSON.parse(coupon);
            if(coupon_.prizeType == 'coupon_code'){
                if (copyButton.classList.contains('copied')) return;
                    
                    navigator.clipboard.writeText(coupon_.prizeValue).then(() => {
                        // 显示打勾SVG图标
                        const originalText = copyButton.textContent;
                        copyButton.innerHTML = `${originalText}
                            <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                                <path d="M13.3332 4L5.99984 11.3333L2.6665 8" stroke="white" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
                            </svg>
                        `;
                        copyButton.classList.add('copied');
                        
                        // 3秒后恢复原始状态
                        setTimeout(() => {
                            copyButton.innerHTML = originalText;
                            copyButton.classList.remove('copied');
                        }, 3000);
                    }).catch(err => {
                        console.error('Failed to copy coupon code: ', err);
                });
            }
            if(coupon_.prizeType == 'product_coupon'){
                let maxTime= 0
                let copyButtonTimer = setInterval(() => {
                    if(copyButton.classList.contains('is-success')){
                        Swal.close();
                        clearInterval(copyButtonTimer);
                    }
                    maxTime += 50;
                }, 10);
                if(maxTime >= 3000){
                    Swal.close();
                    clearInterval(copyButtonTimer);
                }
                // 防止重复点击
                if (copyButton.classList.contains('copied')) return;
                
                navigator.clipboard.writeText(coupon_.prizeValue).then(() => {
                    // 显示打勾SVG图标
                    const originalText = copyButton.textContent;
                    copyButton.classList.add('copied');
                    
                    // 3秒后恢复原始状态
                    setTimeout(() => {
                        copyButton.innerHTML = originalText;
                        copyButton.classList.remove('copied');
                    }, 3000);
                }).catch(err => {
                    console.error('Failed to copy coupon code: ', err);
                });
            }
        }
        // View Prize Popup
        viewPrizePopup() {
            let rgLotteryItem = ``;
            const shopCurrency = window.Shopify.currency.active || 'USD';
            const shopLocale = window.Shopify.locale + '-' + window.Shopify.country || 'en-GB';
            const formatter = new Intl.NumberFormat(shopLocale, {
                style: 'currency',
                currency: shopCurrency
            });
            const currency = 'A$' || formatter.formatToParts(0).find(p => p.type === 'currency').value;
            let lotteryUserList = localStorage.getItem('lotteryUserList');
            this.lotteryUserList = JSON.parse(lotteryUserList);
            if(this.lotteryUserList.length > 0){
                this.lotteryUserList.forEach((item,index) => { 
                    let rgLotteryContent = ``;
                    if(item.couponList.length > 0){
                        item.couponList.forEach((coupon,couponIndex)=>{
                            let membershipCouponRuleHtml = ``;
                            if(coupon?.settings?.rules?.length > 0) {
                                membershipCouponRuleHtml = coupon?.settings?.rules;
                            }
                            if(coupon.prizeType === 'coupon_code'){
                                
                                rgLotteryContent += `
                                <div class="membership-coupon-dialog-content-success membership-coupon-container">
                                    <div class="membership-coupon-dialog-title" style="${couponIndex ===0 ? '' :'display:none;'}">
                                        ${item.email}
                                    </div>
                                    <div class="membership-coupon-item">
                                        <div class="membership-coupon-top">
                                            <div class="coupon-l">
                                                <div class="coupon-name">
                                                    ${coupon?.settings?.couponTypeName !== '%' ? `<span class="copun-currency">${currency}</span>`:'' }
                                                    <span x-text="coupon.couponAmount">
                                                        ${coupon?.settings?.prize_name || ''}
                                                    </span>
                                                    ${coupon?.settings?.couponTypeName === '%' ? `<span class="copun-currency">%</span>`:'' }
                                                    <span class="off-text">${this.messages.couponInfo.off}</span>
                                                </div>
                                                <div class="account-coupon-info">
                                                    ${coupon?.settings?.prize_description || ''}  
                                                    ${currency} 
                                                    <span x-text="coupon.minPurchase">${coupon?.settings?.minPurchase || ''}</span>
                                                </div>
                                            </div>
                                        </div>
                                        <div class="membership-coupon-b">
                                            <div class="membership-coupon-b-top">
                                                <div class="membership-coupon-b-top-content">
                                                    <div class="membership-coupon-b-top-content-title">${this.messages.couponInfo.code}</div>
                                                    <div class="membership-coupon-b-top-content-des">
                                                        ${coupon.prizeValue || ''}
                                                    </div>
                                                </div>
                                                <div class="membership-coupon-b-top-button membership-coupon-b-top-button-copy" data-copy-coupon='${JSON.stringify(coupon)}'>
                                                    ${this.messages.couponInfo.redeem_copy}
                                                </div>
                                                
                                            </div>
                                            <div class="membership-coupon-b-line"></div>
                                            <div class="membership-coupon-b-bottom">
                                                <div class="membership-coupon-b-bottom-time">
                                                    ${coupon?.settings?.valid_date || ''}
                                                </div>
                                            </div>
                                            
                                        </div>
                                    </div>
                                    <div class="membership-coupon-b-bottom-rules-container">
                                        <div class="membership-coupon-b-bottom-rules-title">${this.messages.couponInfo.rules}</div>
                                        <div class="membership-coupon-b-bottom-rules-box">
                                            ${membershipCouponRuleHtml}
                                        </div> 
                                    </div>
                                </div>`;
                            }
                            if(coupon.prizeType === 'gift_card'){
                               
                                rgLotteryContent += `
                                <div class="membership-coupon-dialog-content-success membership-coupon-container gift-card-coupon-dialog-success">
                                    <div class="membership-coupon-dialog-title" style="${couponIndex ===0 ? '' :'display:none;'}">
                                        ${item.email}
                                    </div>
                                    <div class="membership-coupon-item">
                                        <div class="membership-coupon-top">
                                            <div class="coupon-l">
                                                <div class="coupon-name">
                                                    <span class="copun-currency">${currency}</span>
                                                    <span x-text="coupon.couponAmount">${coupon?.settings?.prize_name || ''}</span>
                                                </div>
                                                <div class="account-coupon-info">
                                                    ${coupon?.settings?.prize_description || ''}  
                                                    ${currency} 
                                                    <span x-text="coupon.minPurchase">${coupon?.settings?.minPurchase || ''}</span>
                                                </div>
                                            </div>
                                        </div>
                                        <div class="membership-coupon-b">
                                            <div class="membership-coupon-b-top">
                                                <div class="membership-coupon-b-top-content">
                                                    <div class="membership-coupon-b-top-content-title">${this.messages.couponInfo.gift_card_code}</div>
                                                    <div class="membership-coupon-b-top-content-des">
                                                        ${this.messages.couponInfo.check_email}
                                                    </div>
                                                </div>
                                            </div>
                                            <div class="membership-coupon-b-line"></div>
                                            <div class="membership-coupon-b-bottom">
                                                <div class="membership-coupon-b-bottom-time">
                                                    ${coupon?.settings?.valid_date}
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    <div class="membership-coupon-b-bottom-rules-container">
                                        <div class="membership-coupon-b-bottom-rules-title">${this.messages.couponInfo.rules}</div>
                                        <div class="membership-coupon-b-bottom-rules-box">
                                            ${membershipCouponRuleHtml}
                                        </div> 
                                    </div>
                                </div>`;
                            }
                            if(coupon.prizeType === 'product_coupon'){
                               
                                rgLotteryContent += `
                                <div class="membership-coupon-dialog-content-success membership-coupon-container product-card-coupon-dialog-success">
                                    <div class="membership-coupon-dialog-title" style="${couponIndex ===0 ? '' :'display:none;'}">
                                        ${item.email}
                                    </div>
                                    <div class="membership-coupon-item">
                                        <div class="membership-coupon-top membership-coupon-product-card">
                                            ${coupon?.product?.featured_image?.src?
                                            `<div class="product-card-img" >
                                                <img width="100%" src="${coupon?.product?.featured_image?.src}" />
                                            </div>`:
                                            `<div class="product-card-img" style="background:#F2FCFF;"></div>`}
                                            <div class="product-card-content">
                                                <a class="product-card-content-title" target="_blank" href="${coupon?.product?.url}">${coupon?.product?.name || ''}</a>

                                                <div class="product-card-content-sku">${coupon?.product?.sku || ''}</div>
                                                <div class="product-card-content-price">
                                                    <span class="free">${this.messages.couponInfo.free}</span>
                                                    ${coupon?.product?.price ? `<span class="underline-price">${currency} ${coupon?.product?.price / 100}</span>` :''}
                                                </div>
                                            </div>
                                        </div>
                                        <div class="membership-coupon-item-line-box">
                                            <div class="membership-coupon-item-line"></div>
                                        </div>
                                        <div class="membership-coupon-b">
                                            <div class="membership-coupon-b-top">
                                                <div class="membership-coupon-b-top-content">
                                                    <div class="membership-coupon-b-top-content-title">${this.messages.couponInfo.code}:
                                                        <span class="membership-coupon-b-top-content-des">
                                                            ${coupon.prizeValue}
                                                        </span>
                                                    </div>
                                                </div>
                                                ${coupon.product?.id? `<product-form>
                                                    <form class="js-product-form" id="form-id-${coupon.product.id}"  method="post" action="/cart/add" enctype="multipart/form-data" novalidate="novalidate" accept-charset="UTF-8">
                                                        <input type="hidden" name="form_type" value="product"><input type="hidden" name="utf8" value="✓">
                                                        <input type="hidden" name="id" value="${coupon.product.id}" disabled>
                                                        <button name="add" class="membership-coupon-b-top-button membership-coupon-b-top-button-copy btn btn--secondary quick-add-view-btn" data-copy-coupon='${JSON.stringify(coupon)}'>
                                                            ${this.messages.couponInfo.redeem_copy}
                                                        </button>
                                                    </form>
                                                </product-form>` : ''}
                                                
                                            </div>
                                            <div class="membership-coupon-b-bottom">
                                                <div class="membership-coupon-b-bottom-time">
                                                    ${coupon?.settings?.valid_date}
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    <div class="membership-coupon-b-bottom-rules-container">
                                        <div class="membership-coupon-b-bottom-rules-title">${this.messages.couponInfo.rules}</div>
                                        <div class="membership-coupon-b-bottom-rules-box">
                                            ${membershipCouponRuleHtml}
                                        </div> 
                                    </div>
                                </div>
                            `
                            }
                            
                        })
                    }
                    rgLotteryItem += `<div class="rg-lottery-item">
                        ${rgLotteryContent}
                    </div>`
                })
            }
            const prizeHtml = `
                <div class="rg-lottery-container">
                    ${rgLotteryItem}
                </div>
            `;
            Swal.fire({
                showCloseButton: true,
                showCancelButton: false,
                showConfirmButton: false,
                html: prizeHtml,
                closeButtonHtml: this.closeBtnHtml,
                customClass: {
                    container: "membership-coupon-popup-container",
                    popup: "membership-coupon-popup",
                },
            });
        }

        // 处理blocks数据
        processBlocksData() {
            this.blocks.forEach((block, index) => {
                console.log(`Block ${index}:`, block);
                
                // 可以根据prize_id进行特殊处理
                if (block.settings.prize_id !== 'prize_none') {
                    console.log(`Prize ${block.settings.prize_id}: ${block.settings.prize_name}`);
                }
            });
        }

        // 根据prize_id获取block数据
        getBlockByPrizeId(prizeId) {
            return this.blocks.find(block => block.settings.prize_id === prizeId);
        }

        // 获取所有有效的奖品（非prize_none）
        getValidPrizes() {
            return this.blocks.filter(block => block.settings.prize_id !== 'prize_none');
        }

        initEventListeners() {
           this.form.addEventListener('submit', () => {
            event.preventDefault();
            this.checkFormValidity();
            if (!this.checkFormValidity()) {
                this.renderEmailError();
                return;
            }
            let lotteryCount = Number(this.getLotteryCookie(this.activity)?.lotteryCount) || 0
            if(lotteryCount >= this.maxTime){
                this.renderToast(this.toastTipsIcon,this.messages.couponInfo.no_draw_time_tips,3000);
            }else{
                this.submitForm();  
            }
           });

           
        }
        // toast
        renderToast(toastIcon,msg,duration = 6000){
            Swal.fire(
                {
                    toast: true,
                    position: 'center',
                    title: msg,
                    customClass: {
                    popup: 'custom-error-toast',
                    container: 'custom-error-toast-container',
                    },
                    iconHtml:toastIcon,
                    showConfirmButton: false,
                    timer: duration,
                    didClose: () => {
                        this.submitBtn.disabled = false;
                    }
                }
            )
        }
      
        // 优惠券弹窗
        renderCouponDialog(couponInfo,targetPrizeId,email){
            // 根据您店铺的GBP设置
            const shopCurrency = window.Shopify.currency.active || 'USD';
            const shopLocale = window.Shopify.locale + '-' + window.Shopify.country || 'en-GB';
            const formatter = new Intl.NumberFormat(shopLocale, {
                style: 'currency',
                currency: shopCurrency
            });
            const currency = 'A$' || formatter.formatToParts(0).find(p => p.type === 'currency').value;

            const couponInfoNow = window.lotteryBlocksData.blocks.find(block => block.settings.prize_id === targetPrizeId);
            
            // 使用公共函数处理用户和优惠券数据
            this.processAndStoreUserData(email, couponInfo, couponInfoNow);

            let membershipCouponRuleHtml = ``;
            if(couponInfoNow?.settings?.rules?.length > 0) {
                membershipCouponRuleHtml = couponInfoNow?.settings?.rules;
            }
            const membershipCouponDialogSuccess =  this.lotteryRGContainer.parentElement.querySelector('.coupon-dialog-success');
            const membershipCouponDialogClone = membershipCouponDialogSuccess.cloneNode(true);
            membershipCouponDialogClone.innerHTML = `

                    <div class="membership-coupon-dialog-title" style="color:rgba(224, 71, 0, 1);">
                        Congratulations! You got a Coupon Code!
                    </div>
                    <div class="membership-coupon-item">
                        <div class="membership-coupon-top">
                            <div class="coupon-l">
                                <div class="coupon-name">
                                    ${couponInfoNow?.settings?.couponTypeName !== '%' ? `<span class="copun-currency">${currency}</span>`:'' }
                                    <span x-text="coupon.couponAmount">
                                        ${couponInfoNow?.settings?.prize_name}
                                    </span>
                                    ${couponInfoNow?.settings?.couponTypeName === '%' ? `<span class="copun-currency">%</span>`:'' }
                                    <span class="off-text">${this.messages.couponInfo.off}</span>
                                </div>
                                <div class="account-coupon-info">
                                     ${couponInfoNow?.settings?.prize_description || ''}  
                                     ${currency} 
                                    <span x-text="coupon.minPurchase">${couponInfoNow?.settings?.minPurchase || ''}</span>
                                </div>
                            </div>
                        </div>
                        <div class="membership-coupon-b">
                            <div class="membership-coupon-b-top">
                                <div class="membership-coupon-b-top-content">
                                    <div class="membership-coupon-b-top-content-title">${this.messages.couponInfo.code}</div>
                                    <div class="membership-coupon-b-top-content-des">
                                        ${couponInfo.prizeValue || ''}
                                    </div>
                                </div>
                                <div class="membership-coupon-b-top-button membership-coupon-b-top-button-copy" data-coupon-id="${couponInfo.couponTemplateId}" >
                                    ${this.messages.couponInfo.redeem_copy}
                                </div>
                                
                            </div>
                            <div class="membership-coupon-b-line"></div>
                            <div class="membership-coupon-b-bottom">
                                <div class="membership-coupon-b-bottom-time">
                                    ${couponInfoNow?.settings?.valid_date || ''}
                                </div>
                            </div>
                            
                        </div>
                    </div>
                    <div class="membership-coupon-b-bottom-rules-container">
                        <div class="membership-coupon-b-bottom-rules-title">${this.messages.couponInfo.rules}</div>
                        <div class="membership-coupon-b-bottom-rules-box">
                            ${membershipCouponRuleHtml}
                        </div> 
                    </div>
            `;
            
            Swal.fire({
                showCloseButton: true,
                showCancelButton: false,
                showConfirmButton: false,
                html: membershipCouponDialogClone,
                closeButtonHtml: this.closeBtnHtml,
                customClass: {
                    container: "membership-coupon-popup-container",
                    popup: "membership-coupon-popup",
                },
            }).then(() => {
                // 弹窗关闭后清理操作
            });

            const copyButton = membershipCouponDialogClone.querySelector('.membership-coupon-b-top-button-copy');
            if (copyButton) {
                copyButton.addEventListener('click', () => {
                    // 防止重复点击
                    if (copyButton.classList.contains('copied')) return;
                    
                    navigator.clipboard.writeText(couponInfo.prizeValue).then(() => {
                        // 显示打勾SVG图标
                        const originalText = copyButton.textContent;
                        copyButton.innerHTML = `${originalText}
                            <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                                <path d="M13.3332 4L5.99984 11.3333L2.6665 8" stroke="white" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
                            </svg>
                        `;
                        copyButton.classList.add('copied');
                        
                        // 3秒后恢复原始状态
                        setTimeout(() => {
                            copyButton.innerHTML = originalText;
                            copyButton.classList.remove('copied');
                        }, 3000);
                    }).catch(err => {
                        console.error('Failed to copy coupon code: ', err);
                    });
                });
            }
        }

        // 礼品卡弹窗
        renderGiftCardCouponDialog(couponInfo,targetPrizeId,email){
            // 根据您店铺的GBP设置
            const shopCurrency = window.Shopify.currency.active || 'USD';
            const shopLocale = window.Shopify.locale + '-' + window.Shopify.country || 'en-GB';
            const formatter = new Intl.NumberFormat(shopLocale, {
                style: 'currency',
                currency: shopCurrency
            });
            const currency = 'A$' || formatter.formatToParts(0).find(p => p.type === 'currency').value;
            const couponInfoNow = window.lotteryBlocksData.blocks.find(block => block.settings.prize_id === targetPrizeId);
            
            // 使用公共函数处理用户和优惠券数据
            this.processAndStoreUserData(email, couponInfo, couponInfoNow);
            
            let membershipCouponRuleHtml = ``;
            if(couponInfoNow?.settings?.rules?.length > 0) {
                membershipCouponRuleHtml = couponInfoNow?.settings?.rules;
            }
            
            const membershipCouponDialogSuccess =  this.lotteryRGContainer.parentElement.querySelector('.gift-card-coupon-dialog-success')
            const membershipCouponDialogClone = membershipCouponDialogSuccess.cloneNode(true);
            membershipCouponDialogClone.innerHTML= `
                    <div class="membership-coupon-dialog-title" style="color:rgba(224, 71, 0, 1);">
                        Congratulations! You got Gift Card in your email!
                    </div>
                    <div class="membership-coupon-item">
                        <div class="membership-coupon-top">
                            <div class="coupon-l">
                                <div class="coupon-name">
                                    <span class="copun-currency">${currency}</span>
                                    <span x-text="coupon.couponAmount">${couponInfoNow?.settings?.prize_name || ''}</span>
                                </div>
                                <div class="account-coupon-info">
                                    ${couponInfoNow?.settings?.prize_description || ''}  
                                    ${currency} 
                                    <span x-text="coupon.minPurchase">${couponInfoNow?.settings?.minPurchase || ''}</span>
                                </div>
                            </div>
                        </div>
                        <div class="membership-coupon-b">
                            <div class="membership-coupon-b-top">
                                <div class="membership-coupon-b-top-content">
                                    <div class="membership-coupon-b-top-content-title">${this.messages.couponInfo.gift_card_code}</div>
                                    <div class="membership-coupon-b-top-content-des">
                                        ${this.messages.couponInfo.check_email}
                                    </div>
                                </div>
                            </div>
                            <div class="membership-coupon-b-line"></div>
                            <div class="membership-coupon-b-bottom">
                                <div class="membership-coupon-b-bottom-time">
                                    ${couponInfoNow?.settings?.valid_date || ''}
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="membership-coupon-b-bottom-rules-container">
                        <div class="membership-coupon-b-bottom-rules-title">${this.messages.couponInfo.rules}</div>
                        <div class="membership-coupon-b-bottom-rules-box">
                            ${membershipCouponRuleHtml}
                        </div> 
                    </div>
            `;
            Swal.fire({
                showCloseButton: true,
                showCancelButton: false,
                showConfirmButton: false,
                html: membershipCouponDialogClone,
                closeButtonHtml: this.closeBtnHtml,
                customClass: {
                    container: "membership-coupon-popup-container",
                    popup: "membership-coupon-popup",
                },
            }).then(() => {
                // 弹窗关闭后清理操作
            });
        }
        
        // 商品优惠券弹窗
        renderProductCardCouponDialog(couponInfo,targetPrizeId,email){
            // 根据您店铺的GBP设置
            const shopCurrency = window.Shopify.currency.active || 'USD';
            const shopLocale = window.Shopify.locale + '-' + window.Shopify.country || 'en-GB';
            const formatter = new Intl.NumberFormat(shopLocale, {
                style: 'currency',
                currency: shopCurrency
            });
            const currency = 'A$' || formatter.formatToParts(0).find(p => p.type === 'currency').value;
            const couponInfoNow = window.lotteryBlocksData.blocks.find(block => block.settings.prize_id === targetPrizeId);
            if(window.lotteryBlocksData.product_list.length > 0){
                const productList = window.lotteryBlocksData.product_list;
                const product = productList.flatMap(product => product.variants).find(variant => variant.sku === couponInfo.prizeSku	);
                if(product){
                    couponInfoNow.product = product;
                    // 添加变体 URL，由产品 handle 和变体 ID 拼接而成
                    // 需要找到包含该变体的产品对象来获取 handle
                    const parentProduct = productList.find(p => p.variants.some(v => v.sku === couponInfo.prizeSku));
                    if (parentProduct && parentProduct.handle && product.id) {
                        couponInfoNow.product.url = `/${parentProduct.handle}?variant=${product.id}`;
                    }
                }
            }
            // 使用公共函数处理用户和优惠券数据
            this.processAndStoreUserData(email, couponInfo, couponInfoNow);
            
            let membershipCouponRuleHtml = ``;
            if(couponInfoNow?.settings?.rules?.length > 0) {
                membershipCouponRuleHtml = couponInfoNow?.settings?.rules;
            }
            const membershipCouponDialogSuccess =  this.lotteryRGContainer.parentElement.querySelector('.product-card-coupon-dialog-success')
            const membershipCouponDialogClone = membershipCouponDialogSuccess.cloneNode(true);
            membershipCouponDialogClone.innerHTML = `
                    <div class="membership-coupon-dialog-title" style="color:rgba(224, 71, 0, 1);">
                        Congratulations! You got a Free Gift!
                    </div>
                    <div class="membership-coupon-item">
                        <div class="membership-coupon-top membership-coupon-product-card">
                            ${couponInfoNow?.product?.featured_image?.src?
                            `<div class="product-card-img" >
                                <img width="100%" src="${couponInfoNow?.product?.featured_image?.src}" />
                            </div>`:
                            `<div class="product-card-img" >
                                <img width="100%" src="${couponInfoNow?.settings?.image}" />
                            </div>`}
                            <div class="product-card-content">
                                <a class="product-card-content-title" target="_blank" href="${couponInfoNow?.product?.url || ''}">${couponInfoNow?.product?.name || ''}</a>
                                <div class="product-card-content-sku">${couponInfoNow?.product?.sku || ''}</div>
                                <div class="product-card-content-price">
                                    <span class="free">${this.messages.couponInfo.free}</span>
                                    ${couponInfoNow?.product?.price? `<span class="underline-price">${currency} ${couponInfoNow?.product?.price / 100}</span>` : ''}
                                </div>
                            </div>
                        </div>
                        <div class="membership-coupon-item-line-box">
                            <div class="membership-coupon-item-line"></div>
                        </div>
                        <div class="membership-coupon-b" style="gap:0;">
                            <div class="membership-coupon-b-top">
                                <div class="membership-coupon-b-top-content">
                                    <div class="membership-coupon-b-top-content-title">${this.messages.couponInfo.code}:
                                        <span class="membership-coupon-b-top-content-des">
                                            ${couponInfo.prizeValue || ''}
                                        </span>
                                    </div>
                                </div>
                                ${couponInfoNow.product?.id? `<product-form>
                                    <form class="js-product-form" id="form-id-${couponInfoNow.product.id}"  method="post" action="/cart/add" enctype="multipart/form-data" novalidate="novalidate" accept-charset="UTF-8">
                                        <input type="hidden" name="form_type" value="product"><input type="hidden" name="utf8" value="✓">
                                        <input type="hidden" name="id" value="${couponInfoNow.product.id}" disabled>
                                        <button name="add" class="membership-coupon-b-top-button membership-coupon-b-top-button-copy btn btn--secondary quick-add-view-btn" data-coupon-id="${couponInfo.couponTemplateId}" >
                                            ${this.messages.couponInfo.redeem_copy}
                                        </button>
                                    </form>
                                </product-form>`:''} 
                                
                            </div>
                            <div class="membership-coupon-b-bottom">
                                <div class="membership-coupon-b-bottom-time">
                                    ${couponInfoNow?.settings?.valid_date}
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="membership-coupon-b-bottom-rules-container">
                        <div class="membership-coupon-b-bottom-rules-title">${this.messages.couponInfo.rules}</div>
                        <div class="membership-coupon-b-bottom-rules-box">
                            ${membershipCouponRuleHtml}
                        </div> 
                    </div>
                `
            Swal.fire({
                showCloseButton: true,
                showCancelButton: false,
                showConfirmButton: false,
                html: membershipCouponDialogClone,
                closeButtonHtml: this.closeBtnHtml,
                customClass: {
                    container: "membership-coupon-popup-container",
                    popup: "membership-coupon-popup",
                },
            }).then(() => {
                // 弹窗关闭后清理操作
            });
            const copyButton = membershipCouponDialogClone.querySelector('.membership-coupon-b-top-button-copy');
            if (copyButton) {
                copyButton.addEventListener('click', () => {
                    let maxTime= 0
                    let copyButtonTimer = setInterval(() => {
                        if(copyButton.classList.contains('is-success')){
                            Swal.close();
                            clearInterval(copyButtonTimer);
                        }
                        maxTime += 50;
                    }, 10);
                    if(maxTime >= 3000){
                        Swal.close();
                        clearInterval(copyButtonTimer);
                    }
                    // 防止重复点击
                    if (copyButton.classList.contains('copied')) return;
                    
                    navigator.clipboard.writeText(couponInfo.prizeValue).then(() => {
                        // 显示打勾SVG图标
                        const originalText = copyButton.textContent;
                        copyButton.classList.add('copied');
                        
                        // 3秒后恢复原始状态
                        setTimeout(() => {
                            copyButton.innerHTML = originalText;
                            copyButton.classList.remove('copied');
                        }, 3000);
                    }).catch(err => {
                        console.error('Failed to copy coupon code: ', err);
                    });
                });
            }
        }

        /**
         * 处理并存储用户和优惠券数据
         * @param {string} email - 用户邮箱
         * @param {Object} couponInfo - 当前优惠券信息
         * @param {Object} couponInfoNow - 优惠券模板信息
         */
        processAndStoreUserData(email, couponInfo, couponInfoNow) {
            // 从localStorage获取现有的用户列表
            let userList = [];
            try {
                const storedUserList = localStorage.getItem('lotteryUserList');
                if (storedUserList) {
                    userList = JSON.parse(storedUserList);
                }
            } catch (e) {
                console.error('Error parsing stored user list:', e);
                userList = [];
            }
            
            // 创建当前优惠券对象
            const currentCoupon = Object.assign({}, couponInfoNow, couponInfo);
            
            // 查找是否已存在该邮箱的用户
            const existingUserIndex = userList.findIndex(user => user.email === email);
            
            if (existingUserIndex !== -1) {
                // 如果用户已存在，将新的优惠券添加到其couponList中
                userList[existingUserIndex].couponList.push(currentCoupon);
            } else {
                // 如果用户不存在，创建新用户对象
                userList.push({
                    email: email,
                    couponList: [currentCoupon]
                });
            }
            
            // 将更新后的用户列表存储到localStorage
            try {
                localStorage.setItem('lotteryUserList', JSON.stringify(userList));
            } catch (e) {
                console.error('Error storing user list:', e);
            }
        }

        couponExpiresHandler(coupon) {
            const createDate = coupon.createDate;
            const couponExpires = coupon.couponExpires || coupon.giftCardExpires;
            let startDate = new Date(createDate);
            let couponExpiresNew = Number(couponExpires);
        
            if (isNaN(startDate.getTime())) {
                throw new Error('无效的开始时间格式');
            }
            
            const tenDaysInMs = couponExpiresNew * 24 * 60 * 60 * 1000;
            const resultDate = new Date(startDate.getTime() + tenDaysInMs);
            const resultDateYear = resultDate.getFullYear();
            const resultDateMonth = (resultDate.getMonth() + 1) > 9 ? `${resultDate.getMonth() + 1}` : `0${resultDate.getMonth() + 1}`;
            const resultDateDay = resultDate.getDate() > 9 ? `${resultDate.getDate()}` : `0${resultDate.getDate()}`;
            return resultDateYear + '-' + resultDateMonth + '-' + resultDateDay ;
        }

        // learn more rules
        learnMoreRules() {
            const learnMoreRulesHtml = this.lotteryRGContainer.querySelector(".rg-lottery-learn-more-rules-text").innerHTML;
            Swal.fire({
                html: learnMoreRulesHtml,
                padding: "0",
                position: "",
                showCloseButton: true,
                showCancelButton: false,
                showConfirmButton: false,
                closeButtonHtml:this.closeBtnHtml,
                customClass: {
                container: "pdp-learnMore-dialog-box",
                popup: "pdp-learnMore-dialog-popup pdp-learnMore-dialog-popup-other",
                },
            });
            
        }

        async submitForm() {
            this.submitBtn.disabled = true;
            // 清除之前的动画状态
            this.clearLotteryAnimation();
            let lotteryCount = Number(this.getLotteryCookie(this.activity)?.lotteryCount || 0)

            // 获取表单中的邮箱
            const emailInput = this.form.querySelector('input[type="email"]');
            const email = emailInput ? emailInput.value : '';
            
            // 在移动端设备上，滚动到奖品区域
            const isMobile = window.matchMedia("(max-width: 768px)").matches;
            if (isMobile) {
                const prizeContainer = this.lotteryRGContainer.querySelector('.prize-product-container');
                if (prizeContainer) {
                    prizeContainer.scrollIntoView({ behavior: 'smooth', block: 'center' });
                }
            }
            
            // 第一阶段：开始无限循环动画
            const animationPromise = this.startLotteryAnimation(100);
            const url = this.apiUrl+`/api/lottery/draw${this.lang ? '?lang='+this.lang :'' }`;
            const _data = { email, storeName: this.storeName,activity: this.activity };
            try {
                const res = await fetch(url, {
                    method: "POST",
                    headers: {
                        "Content-Type": "application/json",
                    },
                    body: JSON.stringify(_data),
                });
                
                const data = await res.json();
                
                // 判断返回的code值
                if (data.code == 200) { 
                    lotteryCount += 1;
                    this.setLotteryCookie(this.activity,lotteryCount);
                    if (data.data.success) {
                        // 获取中奖的 prizeId
                        const targetPrizeId = data.data.prizeId || data.data.prize_id || 'prize_1';
                        // 第二阶段：设置目标，让动画连续地停在目标位置
                        this.setLotteryTarget(targetPrizeId);
                        
                        // 等待动画完成
                        await animationPromise;
                        
                        // 动画结束后显示对应弹窗
                        if(data.data.prizeType === 'coupon_code'){
                            this.renderCouponDialog(data.data,targetPrizeId,email);
                        }
                        // 礼品卡弹窗
                        if(data.data.prizeType === 'gift_card'){
                            this.confirmSubmitForm(data.data,targetPrizeId,email);
                        }
                        // 商品卡优惠券弹窗
                        if(data.data.prizeType === 'product_coupon'){
                            this.renderProductCardCouponDialog(data.data,targetPrizeId,email);
                        }
                        this.showViewPrizeButton();
                    } else {
                        // 未中奖，随机选择一个未中奖产品
                        this.setLotteryTarget('prize_none', true);
                        await animationPromise;
                        this.notLucky();
                    }
                } else { 
                    // 请求失败，停止动画
                    this.clearLotteryAnimation();
                    this.renderToast(this.toastErrorIcon, data.msg || "Request failed", 6000);
                }
                this.submitBtn.disabled = false;
            } catch(error) {
                console.error("Fetch error:", error);
                // 出错时停止动画
                this.clearLotteryAnimation();
                this.submitBtn.disabled = false;
                this.renderToast(this.toastErrorIcon, "Network error", 6000);
            }
        }

        async confirmSubmitGiftCard(targetPrizeId,email,fixEmail) { 
            const url = this.apiUrl+`/api/lottery/claim${this.lang ? '?lang='+this.lang :'' }`;
        
            const _data = { email, storeName: this.storeName,activity: this.activity, prizeId:targetPrizeId };
            if(fixEmail !== email){
                _data.fixEmail = fixEmail;
            }
            try {
                const res = await fetch(url, {
                    method: "POST",
                    headers: {
                        "Content-Type": "application/json",
                    },
                    body: JSON.stringify(_data),
                });
                
                
            } catch(error) {
                console.error("Fetch error:", error);
                
            }
        }
        getSite(){
            const currentDomain = window.location.hostname;
            switch (currentDomain) {
            case "uk.renogy.com":
                return {site:"UK",apiUrl:`https://shopify-api.renogy.com`};
            case "www.renogy.com":
                return {site:"US",apiUrl:`https://shopify-api.renogy.com`};
            case "ca.renogy.com":
                return {site:"CA",apiUrl:`https://shopify-api.renogy.com`};
            case "au.renogy.com":
                return {site:"AU",apiUrl:`https://shopify-api.renogy.com`};
            case "de.renogy.com":
                return {site:"DE",apiUrl:`https://shopify-api.renogy.com`};
            case "jp.renogy.com":
                return {site:"JP",apiUrl:`https://shopify-api.renogy.com`};
            case "fr.renogy.com":
                return {site:"FR",apiUrl:`https://shopify-api.renogy.com`};
            case "nl.renogy.com":
                return {site:"NL",apiUrl:`https://shopify-api.renogy.com`};
            case "it.renogy.com":
                return {site:"IT",apiUrl:`https://shopify-api.renogy.com`};
            case "es.renogy.com":
                return {site:"ES",apiUrl:`https://shopify-api.renogy.com`};
            default:
                return {site:"RenogyTest",apiUrl:`https://d-shopify-api.renogy.cn`};
            }
        }

        // 二次确认提交表单
        confirmSubmitForm(couponInfo,targetPrizeId,email){
            const confirmHtml = `
                <div class="membership-coupon-confirm-container membership-coupon-dialog-content-success membership-coupon-container">
                    <div class="membership-coupon-dialog-title" style="color:rgba(224, 71, 0, 1);">
                        <svg xmlns="http://www.w3.org/2000/svg" width="28" height="28" viewBox="0 0 28 28" fill="none">
                            <rect width="28" height="28" transform="matrix(-1 0 0 1 28 0)" fill="white"/>
                            <path d="M6.6982 14.8717C6.6513 14.7828 6.52399 14.7828 6.47709 14.8717L6.00503 15.7664C5.98694 15.8007 5.95398 15.8246 5.91579 15.8312L4.91898 16.0037C4.81995 16.0208 4.78061 16.1419 4.85066 16.214L5.55571 16.9394C5.58272 16.9672 5.59532 17.006 5.5898 17.0443L5.4458 18.0456C5.43149 18.1451 5.53449 18.22 5.62468 18.1756L6.53249 17.7292C6.56727 17.7121 6.60802 17.7121 6.6428 17.7292L7.55061 18.1756C7.6408 18.22 7.7438 18.1451 7.72949 18.0456L7.58549 17.0443C7.57998 17.006 7.59257 16.9672 7.61958 16.9394L8.32464 16.214C8.39469 16.1419 8.35534 16.0208 8.25631 16.0037L7.25951 15.8312C7.22131 15.8246 7.18835 15.8007 7.17026 15.7664L6.6982 14.8717Z" fill="#FCC161"/>
                            <path d="M12.8684 1.62619C12.7833 1.57266 12.673 1.63631 12.6769 1.73675L12.7154 2.74763C12.7169 2.78636 12.7003 2.82358 12.6706 2.8484L11.8935 3.49617C11.8163 3.56053 11.8428 3.68505 11.9395 3.71245L12.9128 3.98817C12.9501 3.99873 12.9804 4.026 12.9948 4.06198L13.3707 5.00114C13.4081 5.09445 13.5347 5.10776 13.5906 5.02426L14.1536 4.18378C14.1752 4.15158 14.2105 4.13121 14.2492 4.12863L15.2585 4.06129C15.3588 4.0546 15.4106 3.9383 15.3485 3.8593L14.7231 3.06413C14.6992 3.03367 14.6907 2.99381 14.7002 2.95623L14.9481 1.97546C14.9727 1.87801 14.8781 1.79283 14.7837 1.82751L13.8342 2.17654C13.7979 2.18991 13.7573 2.18566 13.7245 2.16501L12.8684 1.62619Z" fill="#FCC161"/>
                            <path d="M2.6806 1.89682C2.58028 1.90309 2.52802 2.01918 2.58983 2.09844L3.21191 2.89618C3.23574 2.92674 3.24405 2.96663 3.2344 3.00417L2.98248 3.98392C2.95745 4.08126 3.05171 4.16683 3.14619 4.13254L4.09711 3.78743C4.13355 3.7742 4.17405 3.77863 4.20677 3.79941L5.06072 4.34175C5.14556 4.39564 5.25608 4.33244 5.25266 4.23199L5.21829 3.22096C5.21697 3.18222 5.2337 3.14506 5.26357 3.12037L6.04325 2.47581C6.12072 2.41177 6.09476 2.28713 5.99817 2.25934L5.026 1.97961C4.98876 1.96889 4.95859 1.9415 4.94433 1.90546L4.57225 0.964757C4.53529 0.871295 4.40873 0.857466 4.35245 0.940738L3.78599 1.77888C3.76429 1.811 3.72892 1.83123 3.69024 1.83365L2.6806 1.89682Z" fill="#FCC161"/>
                            <path d="M4.58458 8.24892C5.15806 8.10862 6.01026 7.97754 6.92376 8.89105C7.83727 9.80455 7.31458 10.9789 8.15547 11.8198C8.99635 12.6607 9.737 12.2265 10.1 12.0673" stroke="#E04700" stroke-width="1.6" stroke-linecap="round"/>
                            <path d="M10.5499 6.06709C10.1081 6.06713 9.7499 6.42535 9.74993 6.86716C9.74998 7.30897 10.1082 7.66715 10.55 7.66712C10.6932 7.6671 10.8962 7.69943 11.0519 7.7768C11.1866 7.84373 11.2369 7.91347 11.2564 8.01142C11.3046 8.254 11.2964 8.38016 11.2873 8.43827C11.2792 8.49037 11.2664 8.52423 11.2247 8.61058C11.1908 8.68106 11.0661 8.91079 11.0417 9.1992C11.0155 9.50934 11.1025 9.79524 11.2355 10.065C11.5346 10.6711 11.9994 10.9908 12.4633 11.128C12.8905 11.2542 13.2822 11.2139 13.434 11.1997C13.8738 11.1583 14.1969 10.7682 14.1556 10.3284C14.1142 9.88848 13.7241 9.56536 13.2842 9.60668C13.1409 9.62015 13.0224 9.6248 12.9168 9.59359C12.8715 9.58019 12.834 9.56117 12.8003 9.53365C12.7676 9.50689 12.7196 9.45675 12.6704 9.35709C12.6605 9.33687 12.6515 9.31442 12.6583 9.29293C12.6623 9.28046 12.6684 9.27064 12.6704 9.26641C12.7301 9.14258 12.8228 8.97574 12.8681 8.68513C12.9126 8.40053 12.9015 8.08055 12.8256 7.69927C12.6855 6.9951 12.2199 6.57061 11.7638 6.34395C11.3287 6.12776 10.8658 6.06706 10.5499 6.06709Z" fill="#E04700"/>
                            <circle cx="0.75" cy="0.75" r="0.75" transform="matrix(-0.707107 0.707107 0.707107 0.707107 15.4973 5.875)" fill="#E04700"/>
                            <circle cx="0.75" cy="0.75" r="0.75" transform="matrix(-0.707107 0.707107 0.707107 0.707107 3.68848 11.0352)" fill="#E04700"/>
                            <path d="M18.2763 9.06294L23.5282 22.4844C23.7824 23.1341 23.1413 23.7752 22.4917 23.521L9.07018 18.2691C8.53293 18.0588 8.38807 17.3663 8.79601 16.9584L16.9656 8.78877C17.3736 8.38083 18.0661 8.52568 18.2763 9.06294Z" fill="white"/>
                            <path d="M22.4921 23.5214C23.1415 23.7753 23.7824 23.1344 23.5286 22.4849L19.7313 12.7823L12.7894 19.7242L22.4921 23.5214ZM8.79604 16.9586C8.38817 17.3666 8.53364 18.059 9.07087 18.2692L10.7565 18.9287L18.9358 10.7493L18.2764 9.06373C18.0662 8.52649 17.3737 8.38099 16.9657 8.78889L8.79604 16.9586Z" fill="#E04700"/>
                        </svg> 
                        Congratulations! You got a Gift Card!
                    </div>
                    <div class="membership-coupon-dialog-content">
                        <div class="membership-coupon-dialog-content-title">Please confirm the email, you will receive GiftCard Code in it.</div>
                        <form method="post" id="subscript-email-confirm" accept-charset="UTF-8" class="form subscript-form" data-lottery-rg-form="">
                            <div class="form__field">
                                <div class="input-with-button input-with-button--md-up">
                                    <input type="email" class="input w-full focus-inset" id="subscript-email-confirm-input" name="sub-email" value="${email}" placeholder="Enter your email..." autocomplete="email" aria-required="true" required="">
                                    <svg xmlns="http://www.w3.org/2000/svg" width="28" height="28" viewBox="0 0 28 28" fill="none">
                                        <rect width="28" height="28" />
                                        <path d="M9.29692 14.3575L9.22924 16.9704L11.8422 16.9028L17.111 11.634L14.5657 9.08868L9.29692 14.3575ZM13.0873 18.4862C12.8337 18.7397 12.4928 18.8869 12.1343 18.8963L8.64919 18.9868C7.84759 19.0077 7.19197 18.3521 7.21288 17.5505L7.30403 14.066C7.31339 13.7075 7.45992 13.366 7.71352 13.1124L13.5755 7.25048C14.1222 6.70374 15.0092 6.70375 15.5559 7.25048L18.9499 10.6445C19.4965 11.1912 19.4959 12.0775 18.9492 12.6242L13.0873 18.4862Z" fill="#1C1C1C"/>
                                        <path d="M15.9802 7.67437L18.5255 10.2197L19.6566 9.08858L17.1113 6.54327L15.9802 7.67437ZM18.8079 12.7657L18.7458 12.8168C18.6126 12.9049 18.4384 12.9049 18.3052 12.8168L18.2431 12.7657L13.4349 7.95748L13.3831 7.89465C13.2952 7.76146 13.295 7.58719 13.3831 7.45409L13.4342 7.39194L16.8281 3.99796C16.9648 3.86128 17.1763 3.84365 17.3315 3.94617L17.3944 3.99796L22.2026 8.80615L22.2537 8.8683C22.3564 9.02359 22.3387 9.23492 22.2019 9.3717L18.8079 12.7657Z" fill="#1C1C1C"/>
                                        <path d="M23 22C23.5523 22 24 22.4477 24 23C24 23.5523 23.5523 24 23 24H5C4.44772 24 4 23.5523 4 23C4 22.4477 4.44772 22 5 22H23Z" fill="#1C1C1C"/>
                                    </svg>
                                </div>
                                <button class="btn btn--primary  subscript-button-confirm">Confirm</button>
                            </div>
                        </form>
                    </div>
                </div>
            `;
            Swal.fire({
                showCloseButton: true,
                showCancelButton: false,
                showConfirmButton: false,
                html: confirmHtml,
                closeButtonHtml: this.closeBtnHtml,
                customClass: {
                    container: "membership-coupon-popup-container",
                    popup: "membership-coupon-popup",
                },
                didOpen:()=>{
                    // 二次弹窗确认
                    const confirmButton = document.querySelector('.subscript-button-confirm');
                    if (confirmButton) {
                        // 监听按钮点击事件
                        confirmButton.addEventListener('click', (e)=>{
                            e.preventDefault();
                            // 获取弹窗内邮箱输入框的值
                            const emailInput = document.getElementById('subscript-email-confirm-input');
                            const emailValue = emailInput ? emailInput.value : '';
                            this.confirmSubmitGiftCard(targetPrizeId,email,emailValue)
                            this.renderGiftCardCouponDialog(couponInfo,targetPrizeId,emailValue);
                        });
                    }
                }
                
            }).then((result) => {
                
            })
        }

        // 未中奖
        notLucky(){
            let lotteryCount = Number(this.getLotteryCookie(this.activity)?.lotteryCount || 0)
            const notLuckyHtml = `
                <div class="membership-coupon-confirm-container membership-coupon-dialog-content-success membership-coupon-container">
                    <div class="membership-coupon-dialog-title">
                        <svg xmlns="http://www.w3.org/2000/svg" width="28" height="28" viewBox="0 0 28 28" fill="none">
                            <rect width="28" height="28" fill="white"/>
                            <circle cx="14" cy="14" r="10" fill="#FCC061"/>
                            <ellipse cx="11.4" cy="12.2004" rx="1.4" ry="1.8" fill="#1C1C1C"/>
                            <ellipse cx="16.6" cy="12.2004" rx="1.4" ry="1.8" fill="#1C1C1C"/>
                            <line x1="11.8" y1="17.1992" x2="16.2" y2="17.1992" stroke="#1C1C1C" stroke-width="2" stroke-linecap="round"/>
                        </svg>
                        Sorry, No Luck This Time
                    </div>
                    ${lotteryCount >= this.maxTime ?`` : `<div class="membership-coupon-dialog-content">
                        <div class="membership-coupon-dialog-content-title" style="text-align:left;">Try more times to win a prize!</div>
                    </div>`}
                </div>
            `;
            Swal.fire({
                showCloseButton: true,
                showCancelButton: false,
                showConfirmButton: false,
                html: notLuckyHtml,
                closeButtonHtml: this.closeBtnHtml,
                customClass: {
                    container: "membership-coupon-popup-container",
                    popup: "membership-coupon-popup",
                }, 
            }) 
        }
        renderEmailError(){}


        checkFormValidity(){
            const termsCheckbox = document.querySelector('.rg-lottery-subscribe-container .terms-checkbox')
            // const emailInput = document.querySelector('.rg-lottery-subscribe-container .input-with-button input')
            // const emailVal = /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(emailInput.value.trim());
            // if (!emailVal) {
            //     this.renderToast(this.toastErrorIcon, this.messages.invalid_email, 5000);
            //     return false;
            // }
            if (!termsCheckbox.checked) {
                // Add shake effect to checkbox
                termsCheckbox.classList.add('shake');
                setTimeout(() => {
                    termsCheckbox.classList.remove('shake');
                }, 500);
                return false;
            }else{
                return true;
            }
        }

        /**
         * 开始抽奖动画（无限循环）
         * @param {number} duration - 每次点亮的时间间隔(ms)，默认100ms
         */
        startLotteryAnimation(duration = 100) {
            // 初始化动画状态
            this.lotteryAnimation = {
                isRunning: true,
                hasTarget: false,
                targetPrizeId: null,
                currentStep: 0,
                duration: duration,
                minLoopsBeforeStop: 2, // 收到目标后至少再转2圈
                prizeItems: Array.from(
                    this.lotteryRGContainer.querySelectorAll('.prize-product-item:not(.prize-product-item-center)')
                ),
                sequence: [0, 1, 2, 4, 7, 6, 5, 3], // 九宫格顺时针顺序
                currentActiveItem: null,
                resolveCallback: null
            };

            if (this.lotteryAnimation.prizeItems.length === 0) {
                return Promise.resolve();
            }

            // 返回一个Promise，当动画完全停止时resolve
            this.lotteryAnimation.promise = new Promise((resolve) => {
                this.lotteryAnimation.resolveCallback = resolve;
            });

            // 开始动画循环
            this._runLotteryAnimationStep();

            return this.lotteryAnimation.promise;
        }

        /**
         * 设置抽奖目标，动画会连续地停在目标位置
         * @param {string} targetPrizeId - 中奖的 data-prize-product-item-id，如果是'prize_none'会随机选择一个未中奖产品
         * @param {boolean} isNoLuck - 是否是未中奖（用于随机选择未中奖产品）
         */
        setLotteryTarget(targetPrizeId, isNoLuck = false) {
            if (!this.lotteryAnimation || !this.lotteryAnimation.isRunning) {
                console.warn('动画未运行，请先调用 startLotteryAnimation()');
                return;
            }

            let targetIndex = -1;
            
            // 如果是未中奖，随机选择一个 prize_none 产品
            if (isNoLuck) {
                const noPrizeItems = [];
                this.lotteryAnimation.prizeItems.forEach((item, index) => {
                    const prizeId = item.getAttribute('data-prize-product-item-id');
                    if (prizeId === 'prize_none') {
                        noPrizeItems.push(index);
                    }
                });
                
                if (noPrizeItems.length > 0) {
                    // 随机选择一个未中奖产品
                    const randomIndex = Math.floor(Math.random() * noPrizeItems.length);
                    targetIndex = noPrizeItems[randomIndex];
                } else {
                    // 没有未中奖产品，不设置目标，直接停止动画
                    this.lotteryAnimation.isRunning = false;
                    this.lotteryAnimation.hasTarget = false;
                    // 清除所有active状态
                    this.lotteryAnimation.prizeItems.forEach(item => {
                        item.classList.remove('active-prize-product-item');
                    });
                    // 等待一段时间后resolve
                    setTimeout(() => {
                        if (this.lotteryAnimation.resolveCallback) {
                            this.lotteryAnimation.resolveCallback();
                        }
                    }, 300);
                    return;
                }
            } else {
                // 找到指定的目标奖品
                this.lotteryAnimation.prizeItems.forEach((item, index) => {
                    const prizeId = item.getAttribute('data-prize-product-item-id');
                    if (prizeId === targetPrizeId) {
                        targetIndex = index;
                    }
                });

                // 如果没找到目标，默认停在第一个
                if (targetIndex === -1) {
                    targetIndex = 0;
                }
            }

            // 计算需要额外转动的步数
            const currentSequenceIndex = this.lotteryAnimation.currentStep % this.lotteryAnimation.sequence.length;
            const targetSequenceIndex = this.lotteryAnimation.sequence.indexOf(targetIndex);
            
            // 至少再转 minLoopsBeforeStop 圈后停在目标位置
            const stepsInOneLoop = this.lotteryAnimation.sequence.length;
            const minSteps = this.lotteryAnimation.minLoopsBeforeStop * stepsInOneLoop;
            
            // 计算从当前位置到目标位置需要的步数
            let stepsToTarget = targetSequenceIndex - currentSequenceIndex;
            if (stepsToTarget <= 0) {
                stepsToTarget += stepsInOneLoop;
            }
            
            // 总步数 = 最小圈数 + 到目标的步数
            // totalSteps-1 对应的位置应该是目标位置，所以这里要确保计算正确
            const totalStepsToStop = minSteps + stepsToTarget;
            
            this.lotteryAnimation.hasTarget = true;
            this.lotteryAnimation.targetPrizeId = targetPrizeId;
            this.lotteryAnimation.targetIndex = targetIndex;
            this.lotteryAnimation.targetSequenceIndex = targetSequenceIndex;
            this.lotteryAnimation.stepsWhenTargetSet = this.lotteryAnimation.currentStep;
            this.lotteryAnimation.totalSteps = this.lotteryAnimation.currentStep + totalStepsToStop;
            
        }

        /**
         * 动画循环的单步执行
         * @private
         */
        _runLotteryAnimationStep() {
            if (!this.lotteryAnimation.isRunning) {
                return;
            }

            const anim = this.lotteryAnimation;

            // 移除上一个active状态
            if (anim.currentActiveItem) {
                anim.currentActiveItem.classList.remove('active-prize-product-item');
            }

            // 计算当前应该点亮哪个位置
            const sequenceIndex = anim.currentStep % anim.sequence.length;
            const prizeIndex = anim.sequence[sequenceIndex];
            anim.currentActiveItem = anim.prizeItems[prizeIndex];
            
            if (anim.currentActiveItem) {
                anim.currentActiveItem.classList.add('active-prize-product-item');
            }


            // 步数+1，准备下一步
            anim.currentStep++;

            // 检查是否已经到达目标位置（步数+1后检查）
            if (anim.hasTarget && anim.currentStep > anim.totalSteps) {
                // 动画结束，当前显示的就是目标位置，保持其active状态
                anim.isRunning = false;
                
                
                // 等待一段时间，让用户看到最终结果，然后再resolve Promise
                setTimeout(() => {
                    if (anim.resolveCallback) {
                        anim.resolveCallback();
                    }
                }, 500); // 停留500ms让用户看到中奖结果
                
                return;
            }

            // 计算下一步的延迟时间（减速效果）
            let nextDuration = anim.duration;
            if (anim.hasTarget) {
                const stepsRemaining = anim.totalSteps - anim.currentStep + 1;
                const slowdownSteps = 8;
                if (stepsRemaining <= slowdownSteps) {
                    // 最后几步逐渐减速
                    nextDuration = anim.duration * (1 + (slowdownSteps - stepsRemaining) * 0.3);
                }
            }

            // 继续下一步
            setTimeout(() => this._runLotteryAnimationStep(), nextDuration);
        }

        /**
         * 停止并清除所有奖品的active状态
         */
        clearLotteryAnimation() {
            if (this.lotteryAnimation) {
                this.lotteryAnimation.isRunning = false;
            }
            const prizeItems = this.lotteryRGContainer.querySelectorAll('.prize-product-item');
            prizeItems.forEach(item => {
                item.classList.remove('active-prize-product-item');
            });
        }

        // 刷新 token：只刷新一次，并排队等待
        refreshAccessToken() {
            if (this.isRefreshing) {
                return this.refreshPromise;
            }

            // 没有 refreshToken 时不调用刷新接口：直接 reject，让外层按未登录/失败处理
            if (!this.refreshToken) {
                // 清空挂起队列，避免 401 时请求一直卡住
                this.pendingRequests = [];
                return Promise.reject(new Error("Refresh token not found"));
            }

            this.isRefreshing = true;

            this.refreshPromise = new Promise((resolve, reject) => {
                fetch(this.API_DOMAIN + "/api/v1/account/pc/do_refresh", {
                    method: "POST",
                    headers: {
                        "X-Token": this.accessToken,
                        "Content-Type": "application/json",
                    },
                    body: JSON.stringify({
                        refreshToken: this.refreshToken,
                    }),
                })
                    .then(response => {
                        if (!response.ok) throw new Error("Refresh failed");
                        return response.json();
                    })
                    .then(resp => {
                        // 使用 js-cookie 设置 cookie（需要确保页面已加载 Cookies）
                        if (typeof Cookies !== 'undefined') {
                            Cookies.set(this.ACCESS_TOKEN_KEY, resp.data.accessToken, {
                                domain: ".renogy.com",
                                expires: 370,
                                sameSite: "strict",
                            });
                            Cookies.set(this.REFRESH_TOKEN_KEY, resp.data.refreshToken, {
                                domain: ".renogy.com",
                                expires: 370,
                                sameSite: "strict",
                            });
                        }

                        // 更新实例中的 token
                        this.accessToken = resp.data.accessToken;
                        this.refreshToken = resp.data.refreshToken;

                        resolve(resp);

                        // 执行所有挂起请求
                        for (let i = 0; i < this.pendingRequests.length; i++) {
                            this.pendingRequests[i]();
                        }
                        this.pendingRequests = [];
                    })
                    .catch(err => {
                        // 刷新失败，清空挂起队列，避免队列泄漏
                        this.pendingRequests = [];
                        reject(err);
                    })
                    .finally(() => {
                        this.isRefreshing = false;
                        this.refreshPromise = null;
                    });
            });

            return this.refreshPromise;
        }

        // 通用的 API 请求方法
        _request(apiPath, options = {}, isRetry = false, isFullUrl = false) {
            const apiUrl = isFullUrl ? apiPath : `/mem-service/api/v1/bigcommerce${apiPath}`;
            
            options.headers = options.headers || {};
            options.headers['Content-Type'] = 'application/json';
            options.headers['X-Token'] = this.accessToken;
            
            const url = isFullUrl ? apiUrl : `${this.API_DOMAIN}${apiUrl}`;
            
            return fetch(url, options)
                .then(response => {
                    if (response.status === 401 && !isRetry) {
                        // Token 过期，排队等待刷新完成
                        return new Promise((resolve, reject) => {
                            this.pendingRequests.push(() => {
                                this._request(apiPath, options, true, isFullUrl).then(resolve).catch(reject);
                            });

                            this.refreshAccessToken().catch(reject); // 刷新失败则中断所有请求
                        });
                    }

                    if (!response.ok) {
                        return response.text().then(text => {
                            throw new Error(`HTTP Error ${response.status}: ${text}`);
                        });
                    }

                    return response.json();
                })
                .catch(error => {
                    throw error;
                });
        }

         // 存储抽奖次数
        setLotteryCookie(activityId, lotteryCount, days = 365) {
            if (!activityId) return false;
            
            const data = {
                activityId: activityId,
                lotteryCount: lotteryCount,
            };
            
            const cookieName = `activity_lottery_${activityId}`; // 修改存储键名为活动相关
            const existingData = this.getLotteryCookie(activityId);
            
            let expires;
            
            if (existingData && existingData.createdAt === new Date().toDateString()) {
                // 同一天内，使用固定过期时间（当天23:59:59）
                const now = new Date();
                const endOfDay = new Date(now.getFullYear(), now.getMonth(), now.getDate(), 23, 59, 59);
                expires = "expires=" + endOfDay.toUTCString();
            } else {
                // 新的一天或新活动，设置新的过期时间
                const date = new Date();
                date.setDate(date.getDate() + days);
                expires = "expires=" + date.toUTCString();
            }
            
            document.cookie = `${cookieName}=${encodeURIComponent(JSON.stringify(data))}; path=/; SameSite=Lax`;
            
            return true;
        }
        // 获取抽奖次数
        getLotteryCookie(activityId) {
            if (!activityId) return null;
            
            const cookieName = `activity_lottery_${activityId}`; // 修改存储键名为活动相关
            const nameEQ = cookieName + "=";
            const cookies = document.cookie.split(';');
            
            for (let i = 0; i < cookies.length; i++) {
                let cookie = cookies[i];
                while (cookie.charAt(0) === ' ') {
                    cookie = cookie.substring(1);
                }
                if (cookie.indexOf(nameEQ) === 0) {
                    try {
                        const cookieValue = decodeURIComponent(cookie.substring(nameEQ.length));
                        return JSON.parse(cookieValue);
                    } catch (e) {
                        console.error('解析Cookie失败:', e);
                        return null;
                    }
                }
            }
            return null;
        }

        getCookie(name) {
            const value = `; ${document.cookie}`;
            const parts = value.split(`; ${name}=`);
            if (parts.length === 2) {
                return parts.pop().split(';').shift();
            }
            return null;
        }
        
        getAccessToken() {
            return this.accessToken;
        }

        getRefreshToken() {
            return this.refreshToken;
        }
    }

    const _lotteryRG = new LotteryRG();
    _lotteryRG.init();
    
    // 挂载到 window 对象，方便调试和测试
    window.lotteryRG = _lotteryRG;
}
